
import { Button } from "@/models/template";
import LoadingComponent from "@/components/LoadingComponent.vue";
import { defineComponent, PropType } from "vue";
import tinycolor from "tinycolor2";

const black = "black";
const white = "white";

const __default__ = defineComponent({
  name: "ButtonComponent",
  components: { LoadingComponent },

  data() {
    return {
      isLoading: false,
    };
  },

  props: {
    button: {
      required: true,
      type: Object as PropType<Button>,
    },
    theme: {
      required: true,
      type: String,
    },
  },

  computed: {
    textColor() {
      const currentColor = tinycolor(this.theme);
      if (currentColor.isLight()) {
        return black;
      }
      return white;
    },

    onHover() {
      const currentColor = tinycolor(this.theme);
      if (currentColor.isLight()) {
        return currentColor.darken(10).toString();
      }
      return currentColor.lighten(10).toString();
    },
  },

  methods: {
    buttonClicked() {
      this.isLoading = true;
      this.$emit("buttonClicked", this.button.action, this.button.actionNext);
    },
  },

  emits: ["buttonClicked"],
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "v83022d56": (_ctx.theme),
  "v316c087c": (_ctx.textColor),
  "v1a905f29": (_ctx.onHover)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__